import styled from "styled-components";

export const Select = styled.div`
    width: 100%;
    z-index: 100;
    position: absolute;
    background-color: white;
    top: 45px;
    border-radius: 4px;

    border: ${(props) => `1px solid ${props.theme.colors.breathing}`};
`;
